import ApiService from '../api.service';
import { FirebaseFunctionNames } from 'core/constants/firebase-function-names';
import {
  IDeliveryRequestSettings,
  IPartner,
  IRequestTypeInput,
  IRoutingTable,
} from './delivery-request-routing-api-interface';

/**
 * The routing table D-Hive maintain themselves.
 *
 * Every call is role-gated on the backend to super and logistics admins: the
 * table decides what happens to every inbound request, including which
 * supplier a job is forwarded to.
 */
const DeliveryRequestRoutingApiService = {
  get: (): Promise<IRoutingTable> =>
    ApiService.callFunction<IRoutingTable>({}, FirebaseFunctionNames.GET_DELIVERY_REQUEST_ROUTING),

  save: (type: IRequestTypeInput): Promise<{ routing: IRoutingTable }> =>
    ApiService.callFunction<{ routing: IRoutingTable }>(type, FirebaseFunctionNames.SAVE_DELIVERY_REQUEST_TYPE),

  remove: (uid: string): Promise<{ routing: IRoutingTable }> =>
    ApiService.callFunction<{ routing: IRoutingTable }>({ uid }, FirebaseFunctionNames.DELETE_DELIVERY_REQUEST_TYPE),

  saveSettings: (settings: IDeliveryRequestSettings): Promise<{ settings: IDeliveryRequestSettings }> =>
    ApiService.callFunction<{ settings: IDeliveryRequestSettings }>(
      settings,
      FirebaseFunctionNames.SAVE_DELIVERY_REQUEST_SETTINGS,
    ),

  savePartner: (partner: Omit<IPartner, 'uid'> & { uid?: string }): Promise<{ routing: IRoutingTable }> =>
    ApiService.callFunction<{ routing: IRoutingTable }>(partner, FirebaseFunctionNames.SAVE_DELIVERY_REQUEST_PARTNER),

  removePartner: (uid: string): Promise<{ routing: IRoutingTable }> =>
    ApiService.callFunction<{ routing: IRoutingTable }>(
      { uid },
      FirebaseFunctionNames.DELETE_DELIVERY_REQUEST_PARTNER,
    ),

  seedDefaults: (): Promise<{ created: number; routing: IRoutingTable }> =>
    ApiService.callFunction<{ created: number; routing: IRoutingTable }>(
      {},
      FirebaseFunctionNames.SEED_DELIVERY_REQUEST_TYPES,
    ),
};

export default DeliveryRequestRoutingApiService;
